// extracted by mini-css-extract-plugin
export default {"header":"KRAScreen_header__upMCb","container":"KRAScreen_container__3RrO+"};